export default __webpack_public_path__ + "static/media/Spatial_C01.0e7cdde3.mp4";